import Axios from '../../Axios'; // Adjust to your actual Axios instance path

export const adminAuthAPI = {
  login: async (email: string, password: string) => {
    const response = await Axios.post('/api/admin/auth/login', { email, password });
    return response.data;
  },
  
  // 🟢 NEW: Logout API call
  logout: async () => {
    const response = await Axios.post('/api/admin/auth/logout');
    return response.data;
  }
};